export default __webpack_public_path__ + "static/media/Spinner-2.3d82b9aa.svg";